import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class UserService {

    public user: any = {};
    constructor(private http: HttpClient) { }

    index(filters = {}) {
        let params = new HttpParams();

        for (let filter in filters) {
            if (filters[filter] == false) {
                continue;
            }

            params = params.append(filter, filters[filter]);
        }

        return this.http.get(`${environment.apiUlr}/users`, { params: params });
    }


    getUser() {
        return this.http.get(`${environment.apiUlr}/me`);
    }

    getTeams() {
        return this.http.get(`${environment.apiUlr}/me/teams`);
    }

    getTeamInvitations() {
        return this.http.get(`${environment.apiUlr}/me/team-invitations`);
    }

    updateCurrentTeam(payload) {
        return this.http.put(`${environment.apiUlr}/me/current-team`, payload);
    }

    getUserProvider() {
        // return this.http.get(`${environment.apiOfficeUrl}/me`);
    }

    updateUser(payload) {
        return this.http.patch(`${environment.apiUlr}/me`, payload);
    }

    isProvider() {
        // return this.http.post(`${environment.apiOfficeUrl}/register`, {});
    }

    getUserFaqs() {
        return this.http.get(`${environment.apiUlr}/faqs`);
    }

    updatePassword(payload) {
        return this.http.patch(`${environment.apiUlr}/me/password`, payload);
    }

    updatePhoto(payload) {
        return this.http.patch(`${environment.apiUlr}/me/photo`, payload);
    }

    destroyPhoto() {
        return this.http.delete(`${environment.apiUlr}/me/photo`);
    }

}
